
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.126 27.129c-.4.2-.8.3-1.2.5-.2.1-.4.6-.4.7-.1.4-.1.8-.1 1.2 0 .3.1.7.3.9.2.2.3.2.5.2.4-.1.8-.3 1.2-.5.2-.1.4-.5.4-.7.1-.4.1-.8.1-1.2 0-.3-.2-1.3-.8-1.1z"}}),_c('path',{attrs:{"d":"M43.826 13.629l-6.3.9c1.2-1.6 2.5-3.2 3.7-4.8.5-.7.1-3.7-.7-2.7-2 2.7-4.1 5.4-6.1 8.1 0 0-.1.1-.1.2-.2-2.7-.4-5.5-.6-8.2 0-.4-.3-1.3-.9-1.1-.6.2-.5 1.5-.5 1.9.2 2.7.4 5.4.6 8-4.7-.9-8.3 2.6-10.7 6.9-.2.1-.3.2-.4.4-.1.2-.1.4-.2.6-.6 1.2-1.2 2.5-1.6 3.8-2.7 7.7-6.1 17.7-4.7 26v.4c.1.6.3.8.4.7.1.1.2.1.4 0 7.3-3.6 13-12.7 17.7-19 3.4-4.7 9.1-13.4 3-18 2.3-.3 4.6-.6 6.9-1 1.1 0 1-3.2.1-3.1zm-7.7 15.1l-1.8 2.7c-.9 1.3-1.9 2.6-2.8 3.9-2.9.7-5.5-.3-7.9-1.9-.8-.5-1.2 2.5-.4 3 1.8 1.2 3.7 2 5.7 2.2-.1.1-.1.2-.2.3-3.4 4.2-7.3 9.8-12.2 12.5-.3-2.9 0-6.1.7-9.3 1.1 1.4 2.9 2.2 4.7 2.2 1 0 1-3.2 0-3.2-1.4 0-3.2-.5-4-1.8 1-3.8 2.4-7.5 3.4-10.4.3-.8.6-1.6 1-2.4 1.2 2.4 3.3 4.1 6.2 4.5.9.1 1-3 0-3.1-2.2-.3-4-1.5-5-3.3 2.3-3.7 5.7-6.9 9.9-5.5.1.1.2.2.4.2h.1c.3.1.6.3 1 .5 2.7 1.6 2.8 6.3 1.2 8.9z"}})])
          )
        }
      }
    